// DARKDEV homepage motion. Respects the visitor's reduced-motion preference.
(() => {
  if (window.darkdevHomeMotionLoaded) return;
  window.darkdevHomeMotionLoaded = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const pointer = matchMedia('(hover: hover) and (pointer: fine)');
  const animations = new Set();
  let enabled = true, frame = 0;
  const layers = [...document.querySelectorAll('.cb-hero-media > img, .cb-design-universe > img, .cb-design-story > img, .cb-boxer-benefits__product > img')];
  const hero = document.querySelector('.cb-slider');
  const cards = [...document.querySelectorAll('#MainContent .cbl-card')];
  function paint() {
    frame = 0;
    if (!enabled || reduced.matches) return;
    const mobile = innerWidth < 750;
    layers.forEach(image => {
      const container = image.closest('.cb-slider') || image.parentElement;
      const rect = container.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > innerHeight) return;
      const progress = container === hero ? -rect.top / Math.max(rect.height, 1) : (innerHeight / 2 - rect.top - rect.height / 2) / innerHeight;
      const limit = Math.min(rect.height * .055, mobile ? 16 : 48);
      image.style.setProperty('--darkdev-parallax', `${Math.max(-limit, Math.min(limit, progress * (mobile ? 32 : 110)))}px`);
    });
    if (hero) hero.style.setProperty('--darkdev-text-y', `${Math.min(38, Math.max(0, -hero.getBoundingClientRect().top * .065))}px`);
  }
  const schedule = () => { if (!frame && enabled && !reduced.matches) frame = requestAnimationFrame(paint); };
  function refresh() {
    document.body.classList.toggle('darkdev-motion', enabled && !reduced.matches);
    animations.forEach(animation => animation.cancel());
    animations.clear();
    cards.forEach(card => { card.style.removeProperty('--darkdev-rx'); card.style.removeProperty('--darkdev-ry'); });
    schedule();
  }
  refresh();
  reduced.addEventListener('change', refresh);
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  layers.forEach(image => image.addEventListener('load', schedule, { once: true }));
  cards.forEach(card => {
    card.addEventListener('pointermove', event => {
      if (!enabled || reduced.matches || !pointer.matches) return;
      const rect = card.getBoundingClientRect();
      card.style.setProperty('--darkdev-rx', `${-(event.clientY - rect.top - rect.height / 2) / rect.height * 5}deg`);
      card.style.setProperty('--darkdev-ry', `${(event.clientX - rect.left - rect.width / 2) / rect.width * 6}deg`);
      card.style.setProperty('--darkdev-light-x', `${(event.clientX - rect.left) / rect.width * 100}%`);
      card.style.setProperty('--darkdev-light-y', `${(event.clientY - rect.top) / rect.height * 100}%`);
    }, { passive: true });
    card.addEventListener('pointerleave', () => { card.style.setProperty('--darkdev-rx', '0deg'); card.style.setProperty('--darkdev-ry', '0deg'); });
  });
  document.querySelectorAll('.cb-design-story__copy').forEach(copy => {
    const signature = copy.querySelector('.darkdev-story-signature');
    if (!signature) return;
    function play() {
      if (!enabled || reduced.matches) return;
      const rect = copy.getBoundingClientRect();
      if (rect.top > innerHeight || rect.bottom < 0) return;
      const sequence = [
        [copy.querySelector('h2'), [{opacity:0,translate:'0 20px'},{opacity:1,translate:'0 0'}], 900, 0],
        [copy.querySelector('.cb-text-link'), [{opacity:0,translate:'0 8px'},{opacity:1,translate:'0 0'}], 650, 1300]
      ];
      sequence.forEach(([target, frames, duration, delay]) => {
        if (typeof target?.animate !== 'function') return;
        const animation = target.animate(frames, {duration,delay,fill:'backwards',easing:'cubic-bezier(.25,.6,.3,1)'});
        animations.add(animation);
        animation.onfinish = () => animations.delete(animation);
      });
    }
    const storyObserver = new IntersectionObserver(entries => {
      if (entries.some(entry=>entry.isIntersecting)) { play(); storyObserver.disconnect(); }
    }, {threshold:.35});
    storyObserver.observe(copy);
  });
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      if (!enabled || reduced.matches) return;
      const target = entry.target;
      const picture = target.matches('.cb-design-universe, .cb-boxer-benefits__product');
      const keyframes = picture ? [{ clipPath: 'inset(8% 3% 8% 3%)', opacity: .6 }, { clipPath: 'inset(0% 0% 0% 0%)', opacity: 1 }] : [{ opacity: 0, translate: '0 38px' }, { opacity: 1, translate: '0 0' }];
      const animation = target.animate(keyframes, { duration: picture ? 1200 : 850, delay: Number(target.dataset.darkdevDelay || 0), easing: 'cubic-bezier(.16,1,.3,1)' });
      animations.add(animation);
      animation.onfinish = () => animations.delete(animation);
    });
  }, { threshold: .1 });
  document.querySelectorAll('#MainContent .cb-section-heading, #MainContent .cbl-card, .cb-design-universe, .cb-boxer-benefits__product, .cb-boxer-benefits__item').forEach((target, index) => {
    target.dataset.darkdevDelay = target.matches('.cbl-card,.cb-boxer-benefits__item') ? String(index % 4 * 70) : '0';
    observer.observe(target);
  });
})();
